"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = require("react-dom/client");
const App_1 = __importDefault(require("./components/App"));
function initApp() {
    const container = document.getElementById('root');
    if (!container) {
        console.error('Root element not found');
        return;
    }
    const root = (0, client_1.createRoot)(container);
    root.render(react_1.default.createElement(react_1.default.StrictMode, null,
        react_1.default.createElement(App_1.default, null)));
}
// Initialize after DOM loads
if (document.readyState === 'complete') {
    initApp();
}
else {
    document.addEventListener('DOMContentLoaded', initApp);
}
